import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Camera"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M2.25 19.5C1.83579 19.5 1.5 19.1642 1.5 18.75V6C1.5 5.58579 1.83579 5.25 2.25 5.25H7.095L8.3775 3.3375C8.51549 3.12796 8.74911 3.0013 9 3H15C15.2509 3.0013 15.4845 3.12796 15.6225 3.3375L16.905 5.25H21.75C22.1642 5.25 22.5 5.58579 22.5 6V18.75C22.5 19.1642 22.1642 19.5 21.75 19.5H2.25ZM7.5 12C7.5 14.4853 9.51472 16.5 12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12ZM9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12ZM21 18H3V6.75H7.5C7.75089 6.7487 7.98451 6.62204 8.1225 6.4125L9.405 4.5H14.595L15.8775 6.4125C16.0155 6.62204 16.2491 6.7487 16.5 6.75H21V18Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Camera.vue"]]);
